export const OPEN_EDIT_FORM_ASSOCIATIONS_MODAL = 'OPEN_EDIT_FORM_ASSOCIATIONS_MODAL';
export const CLOSE_EDIT_FORM_ASSOCIATIONS_MODAL = 'CLOSE_EDIT_FORM_ASSOCIATIONS_MODAL';
export const CLOSE_EDIT_FORM_ASSOCIATIONS_ERROR = 'CLOSE_EDIT_FORM_ASSOCIATIONS_ERROR';

function openEditFormAssociationsModal(currentForm) {
  return {
    type: OPEN_EDIT_FORM_ASSOCIATIONS_MODAL,
    isEditFormAssociationsModalShown: true,
    currentForm
  };
}

function closeEditFormAssociationsModal() {
  return {
    type: CLOSE_EDIT_FORM_ASSOCIATIONS_MODAL,
    isEditFormAssociationsModalShown: false,
    editFormAssociationsResponse: null,
    editFormAssociationsError: null
  };
}

function closeEditFormAssociationsError() {
  return {
    type: CLOSE_EDIT_FORM_ASSOCIATIONS_ERROR,
    isEditFormAssociationsModalShown: true,
  };
}

export function showEditFormAssociationsModal(currentForm) {
  return (dispatch) => {
    dispatch(openEditFormAssociationsModal(currentForm));
  };
}

export function hideEditFormAssociationsModal() {
  return (dispatch) => {
    dispatch(closeEditFormAssociationsModal());
  };
}

export function hideEditFormAssociationsError() {
  return (dispatch) => {
    dispatch(closeEditFormAssociationsError());
  };
}
